import { Gallery } from "react-photoswipe-gallery";
import { PHOTO_SWIPE_OPTIONS } from "./static/ts/const";
import { ReactNode } from "react";
import PhotoSwipeGalleryIconVersionItem from "./components/PhotoSwipeGalleryIconVersionItem/PhotoSwipeGalleryIconVersionItem";

/**
    웹뷰는 모든 동작에 대한 상태 추척이 가능
    1. 다운로드의 시작, 종료 시점 확인 가능
    2. 페이지의 이동, 뒤로가기 등 상태 추적 가능 등...

    따라서 청크로 다운 받는다 하더라도 웹뷰가 알아서 이를 감지하여 청크 다운로드를 진행해준다.

    다운로드 완료 이후 저장경로 설정은 플루터에서 분기처리를 자동으로 해서 ios와 안드로이드 환경에 맞게 적절히 화면이 나오도록 한다
 */

const ReactPhotoSwipeIconVersion = (
    {
        img_list,
        children,
    }:{
        img_list: string[];
        children?: ReactNode;
    }
) => {
    return(
        <Gallery
            options={PHOTO_SWIPE_OPTIONS}
            withCaption
            withDownloadButton
        >
            <PhotoSwipeGalleryIconVersionItem img_list={img_list}>
                {children}
            </PhotoSwipeGalleryIconVersionItem>
        </Gallery>
    )
}

export default ReactPhotoSwipeIconVersion;